import React from 'react';
import TextOrStatus from '../../textOrStatus';
import { H6, TaglineP } from '../../../styles/stylesTypography';
import { theme } from '../../../styles/theme';
import * as S from './styles';
import IconAtencao from "../../../assets/icons/icon-status-nao-enviado.png";
import { isOmie } from '../../../services/globalFunctions';
import { formatQuantidade, formatarData, formatLocal, isCadastroIncompleto, isProdutoIncompativelComEstado, isFazendaAusente, getMotivoAtencao } from './helpers';

const CardSolicitacaoDesktop = ({ item, disabled }) => {
  const incompleto = isCadastroIncompleto(item) || isProdutoIncompativelComEstado(item) || isFazendaAusente(item);

  return (
    <S.LegacyCard>
      
        {incompleto && (
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '4px', alignItems:'center' }}>
            <img
              src={IconAtencao}
              alt="Ícone de atenção"
              title={getMotivoAtencao(item)}
              width="18"
              height="18"
            />
          </div>
        )}
      <S.LegacyTableColumnStart>
        <S.LegacyTableColumnContain className='teste'>
          {item.agro_prescriptions_relations_orders.length > 1 ? (
            <div style={{ width: '100%', height: 'auto', gap: '8px', display: 'flex', flexDirection: 'column' }}>
              {item.agro_prescriptions_relations_orders.map((order, idx) => (
                <div key={`${item.id || 'item'}_desktop_product_${idx}`} style={{ width: '100%', height: 'auto', display: 'flex' }}>
                  <S.LegacyOrderCell>
                    {order ? (
                      <TextOrStatus
                        minWidth="65px"
                        type="text"
                        status="default"
                        textDefault={formatQuantidade(order)}
                        align="center"
                        color={theme.colors.gray.Cinza_2}
                        backgroundColor={theme.colors.gray.Cinza_11}
                        disabled={disabled}
                      />
                    ) : null}
                  </S.LegacyOrderCell>

                  <S.LegacyProductCell $maxWidth="600px">
                    <H6
                      color={disabled ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}
                      fontWeight={800}
                    >
                      {order.nome_comercial}
                    </H6>
                  </S.LegacyProductCell>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ width: '100%', height: 'auto', display: 'flex' }}>
              <S.LegacyOrderCell>
                {item?.agro_prescriptions_relations_orders?.[0] ? (
                  <TextOrStatus
                    minWidth="65px"
                    type="text"
                    status="default"
                    textDefault={formatQuantidade(item)}
                    align="center"
                    color={theme.colors.gray.Cinza_2}
                    backgroundColor={theme.colors.gray.Cinza_11}
                    disabled={disabled}
                  />
                ) : null}
              </S.LegacyOrderCell>
     
              <S.LegacyProductCell $maxWidth="600px">
                <H6
                  color={disabled ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}
                  fontWeight={800}
                >
                  {item.nome_comercial}
                </H6>
              </S.LegacyProductCell>
            </div>
          )}
        </S.LegacyTableColumnContain>

        <S.LegacyMetaRow>
            <TextOrStatus
              minWidth="125px"
              maxWidth="200px"
              type="text"
              status="default"
              textDefault={`${item.id_externo && !isOmie() ? item.id_externo + ': ' : ''}${item.produtor_nome}`}
              color={theme.colors.white.Branco}
              backgroundColor={theme.colors.blue.Azul_link}
              disabled={disabled}
            />

            <TextOrStatus
              minWidth="150px"
              type="text"
              imageSrcType="local"
              status="default"
              textDefault={formatLocal(item)}
              color={theme.colors.blue.Azul_link}
              backgroundColor={theme.colors.gray.Cinza_12}
              disabled={disabled}
            />

            {!isOmie() && item.cultura_nome_comum && (
              <TextOrStatus
                type="text"
                status="default"
                textDefault={item.cultura_nome_comum}
                color={theme.colors.white.Branco}
                backgroundColor={theme.colors.gray.Cinza_2}
                disabled={disabled}
              />
            )}

            {!isOmie() && (
              <TextOrStatus
                minWidth="125px"
                type="text"
                status="default"
                imageSrcType="agronomo"
                textDefault={item.agronomo_nome}
                color={theme.colors.gray.Cinza_2}
                backgroundColor={theme.colors.gray.Cinza_11}
                disabled={disabled}
              />
            )}
          </S.LegacyMetaRow>
      </S.LegacyTableColumnStart>

      <S.LegacyTableColumnEnd>
        <S.LegacyStatusRow>
          <div style={{ width: '100%', height: 'auto', gap: '8px', display: 'flex', justifyContent: 'flex-end' }}>
            <S.LegacyProductCell $justifyContent="flex-end">
              <TextOrStatus
                maxWidth="auto"
                type="status"
                status={item.status}
                textDefault="Em aberto"
                textSuccess="Receita Gerada"
                textError="Receita cancelada"
                textSolicitacaoCancelada="Solicitação cancelada"
                textWaiting="Aguardando liberação"
              />
            </S.LegacyProductCell>

            <S.LegacyOrderCell $paddingRight="8px">
              <TaglineP
                color={disabled ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}
                fontWeight={600}
              >
                {formatarData(item.data_emissao)}
              </TaglineP>
            </S.LegacyOrderCell>
          </div>
        </S.LegacyStatusRow>

        <S.LegacyMetaRow>
          <TaglineP
            color={disabled ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}
            fontWeight={600}
          >
            Pedido: <b>{item.id_pedido}</b>
          </TaglineP>
        </S.LegacyMetaRow>
      </S.LegacyTableColumnEnd>
    </S.LegacyCard>
  );
};

export default CardSolicitacaoDesktop;
